<template>
  <div class="cabinet">
    <div class="cabinet-wrap">
      <div class="cabinet-title">
        {{ $t('bdtlCabinet') }}
      </div>
      <div class="cabinet-content">
        <div class="cabinet-wrap">
          <div class="cabinet-list" v-if="filteredOffersList.length">
            <div class="cabinet-list__head">
              <div>Id</div>
              <div>{{ $t('name') }}</div>
              <div>{{ $t('amount') }}</div>
              <div>{{ $t('package') }}</div>
              <div>{{ $t('users') }}</div>
              <div>{{ $t('action') }}</div>
              <div>$ {{ $t('due') }}</div>
            </div>
            <div class="cabinet-list__item" v-for="item in filteredOffersList" :key="item.id" :class="{ 'notpaid': !item.paid }">
              <div class="cabinet-list__item-id"> {{ item.id }} </div>
              <div class="cabinet-list__item-name"> {{ getOfferNameById(item.packageOfferId) }} </div>
              <div class="cabinet-list__item-amount">{{ item.amount }}</div>
              <div class="cabinet-list__item-package"> {{ getPackageById(item.packageId) }} </div>
              <div class="cabinet-list__item-user" v-if="item.userIds">
                <svg @click="showBDTLOfferUserListModal(item)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" version="1.1">
                  <rect width="16" height="16" id="icon-bound" fill="none"/>
                  <path
                    d="M16,12.5C16,11.837 15.737,11.201 15.268,10.732C14.799,10.263 14.163,10 13.5,10C11.447,10 8.553,10 6.5,10C5.837,10 5.201,10.263 4.732,10.732C4.263,11.201 4,11.837 4,12.5C4,14.147 4,15 4,15L16,15C16,15 16,14.147 16,12.5ZM3,13L0,13C0,13 0,12.147 0,10.5C0,9.837 0.263,9.201 0.732,8.732C1.201,8.263 1.837,8 2.5,8L6.536,8C6.754,8.376 7.031,8.714 7.355,9L6.5,9C4.567,9 3,10.567 3,12.5L3,13ZM10,3C11.656,3 13,4.344 13,6C13,7.656 11.656,9 10,9C8.344,9 7,7.656 7,6C7,4.344 8.344,3 10,3ZM6.126,6.997C6.084,6.999 6.042,7 6,7C4.344,7 3,5.656 3,4C3,2.344 4.344,1 6,1C7.026,1 7.932,1.516 8.473,2.302C7.022,2.903 6,4.333 6,6C6,6.344 6.044,6.679 6.126,6.997Z"/>
                </svg>
               <strong>
                 {{ item.userIds.length }} / {{ item.amount }}
                 <span v-if="item.userIds.length === item.amount">(no more avbailable)</span>
               </strong>
              </div>
              <div class="cabinet-list__item-action">
                <button :disabled="item.userIds.length === item.amount" @click.prevent="setOffer(item)">{{ $t('addUserLabel') }}</button>
                <button class="cabinet-list__item-information" v-if="!item.paid" v-tooltip="{
                 trigger: 'hover',
                 content: $t('offerWaitingModeration')}">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="-1 0 19 19" class="cf-icon-svg"><path d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zM9.64 5.78a1.136 1.136 0 1 0-1.136 1.135A1.136 1.136 0 0 0 9.64 5.781zm-.344 2.884a.792.792 0 1 0-1.583 0v5.203a.792.792 0 0 0 1.583 0z"/></svg>
                </button>
              </div>
              <div class="cabinet-list__item-due" :class="{'paid': item.paid}">
                <span v-if="!item.paid">${{ item.price }}</span>
                <span v-else>{{ $t('paid') }}</span>
              </div>
            </div>
          </div>
          <div class="cabinet-list__empty" v-if="!filteredOffersList.length && !agentOffersLoading">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="30px" width="50px" version="1.1" id="XMLID_111_" viewBox="0 0 24 24" xml:space="preserve">
              <path d="M22,24H2V0h14.4L22,5.6V24z M4,22h16V8h-6V2H4V22z M16,6h3.6L16,2.4V6z M14.3,18.7L12,16.4l-2.3,2.3l-1.4-1.4l2.3-2.3    l-2.3-2.3l1.4-1.4l2.3,2.3l2.3-2.3l1.4,1.4L13.4,15l2.3,2.3L14.3,18.7z"/>
            </svg>
            {{ $t('emptyOfferList') }}
            <router-link :to="{ name: 'bdtl-store' }">{{ $t('bdtlStore') }}</router-link>
          </div>
          <transition name="fade" mode="out-in">
            <div class="cabinet-list__loader" v-if="agentOffersLoading">
              <Loader />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

import Loader from '@/components/Spinner'

export default {
  name: 'BDTLCabinet',
  data () {
    return {
      agentOffersLoading: false
    }
  },
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      agentOffers: 'agents/agentOffers',
      offersList: 'agents/offersList',
      packageById: 'entities/packages/find'
    }),
    filteredOffersList () {
      // return this.agentOffers ? this.agentOffers.filter((item) => item.userIds.length !== item.amount) : []
      return this.agentOffers
    },
    isUserBDTLAgent () {
      return this.getPackageById(this.user.package) === 'BDTL Agent' || this.getPackageById(this.user.package) === 'BDTL Agency'
    }
  },
  created () {
    this.getOffers()
    if (!this.offersList.length) {
      this.fetchOffersList()
    }
  },
  watch: {
    user: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.checkAgentPermission()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      fetchAgentOffers: 'agents/fetchAgentOffers',
      fetchOffersList: 'agents/fetchOffersList'
    }),
    checkAgentPermission () {
      if (!this.isUserBDTLAgent) {
        this.$router.push({ name: 'profile' }).catch(() => {})
      }
    },
    async getOffers () {
      try {
        this.agentOffersLoading = true
        await this.fetchAgentOffers()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      } finally {
        this.agentOffersLoading = false
      }
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD MMM YYYY')
      } else {
        return ''
      }
    },
    getOfferNameById (id) {
      let packageName = null
      this.offersList.forEach((item) => {
        if (item.id === id) {
          packageName = item.name
        }
      })
      return packageName
    },
    getPackageById (id) {
      return this.packageById(id) ? this.packageById(id).name : ''
    },
    setOffer (item) {
      this.$modal.show('set-bdtl-offer', { item: item })
    },
    showBDTLOfferUserListModal (item) {
      if (item.userIds.length) {
        this.$modal.show('bdtl-offers-user-list', { item: item })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cabinet {
  padding: 30px 0;
  &-wrap {
    position: relative;
    @include respondTo(750px){
      overflow: auto;
      padding-bottom: 15px;
      &::-webkit-scrollbar {
        width: 8px;
        position: absolute;
        background: rgba(17, 17, 17, 0.1);
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        position: absolute;
        z-index: -2
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(17, 17, 17, 0.4);
        border-radius: 5px;
      }
    }
  }
  &-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.3;
    text-align: center;
    margin-bottom: 20px;
    @include respondTo(600px){
      font-size: 18px;
    }
  }
  &-list {
    user-select: none;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 1000px;
    margin: 0 auto;
    @include respondTo(750px){
      width: 750px;
      overflow: auto;
    }
    &__head {
      width: 100%;
      padding: 10px 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-weight: bold;
      font-size: 12px;
      line-height: 1.2;
      border-bottom: 1px solid black;
      & div {
        width: 20%;
        text-align: center;
        &:first-child {
          width: 10%;
        }
        &:nth-child(2),
        &:nth-child(5){
          width: 30%;
        }
        &:nth-child(4){
          width: 10%;
        }
      }
    }
    &__item {
      width: 100%;
      padding: 10px 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-size: 12px;
      line-height: 1.2;
      position: relative;
      &.disabled {
        opacity: 0.4;
        pointer-events: none;
      }
      &.notpaid {
        background: #b5b5b5;
      }
      &:not(:first-child){
        border-top: 1px solid #cecece;
      }
      & div {
        width: 20%;
        text-align: center;
        &:first-child {
          width: 10%;
        }
        &:nth-child(5),
        &:nth-child(2){
          width: 30%;
        }
        &:nth-child(4){
          width: 10%;
        }
      }
      &-user {
        svg {
          width: 15px;
          height: 15px;
          margin-right: 5px;
          vertical-align: middle;
          cursor: pointer;
        }
        span {
          display: block;
          font-size: 10px;
        }
      }
      &-action {
        button:first-child {
          padding: 5px 15px;
          background: #00b764;
          color: $white;
          border-radius: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: background $trans;
          &:disabled {
            opacity: 0.5;
            pointer-events: none;
          }
          &:hover {
            background: #02d072;
          }
        }
      }
      &-information {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-left: 10px;
        padding: 0;
        border: none;
        svg {
          vertical-align: middle;
          width: 100%;
          height: 100%;
        }
      }
      &-due {
        color: red;
        font-weight: bold;
        &.paid {
          color: #00b764;
        }
      }
    }
    &__loader{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: #f2f2f2;
      z-index: 3;
      min-height: 5vh;
      display: flex;
      justify-content: center;
      align-items: center;
      @include respondTo(600px){
        min-height: 8vh;
      }
    }
    &__empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 1.2;
      margin-top: 60px;
      margin-bottom: 20px;
      @include respondTo(600px){
        font-size: 14px;
        margin-bottom: 10px;
      }
      a {
        margin-top: 10px;
        text-decoration: underline;
      }
      svg {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
